import "./App.css";
import Nav from "./component/Nav";
import Header from "./component/Header";
import TodoList from "./component/TodoList";
import Footer from "./component/Footer";
import { Provider } from "react-redux";
import Store from "./redux/store";
import CompleteTodoL from "./component/CompleteTodoL";
// import store from "./redux/store";

function App() {
  return (
    <Provider store={Store}>
      <div class="grid place-items-center bg-blue-100 h-screen px-6 font-sans">
        <Nav />
        <div class="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
          <Header />
          <hr class="mt-2" />
          <TodoList />
          <hr class="mt-2" />
          <Footer />
        </div>
        <div class="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
          <h4>Completed Tasks</h4>
          <hr class="mt-2" />
          <CompleteTodoL />
          <hr class="mt-2" />
          <Footer />
        </div>
      </div>
    </Provider>
  );
}

export default App;
